/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable react-refresh/only-export-components */
import "@unocss/reset/tailwind.css";
import "virtual:uno.css";

import { RegrelloNonIdealStateWithRefresh } from "@regrello/ui-core";
import { browserTracingIntegration, consoleLoggingIntegration, init, replayIntegration } from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { RegrelloErrorBoundary } from "./ui2/shared/components/errorBoundary/RegrelloErrorBoundary";
import { onBeforeSentryCaptureOnAppRoot } from "./utils/sentryScopeUtils";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById("root")!;
const root = createRoot(container);

function RootComponent() {
  return (
    <React.StrictMode>
      <RegrelloErrorBoundary
        beforeCapture={onBeforeSentryCaptureOnAppRoot}
        fallback={
          <RegrelloNonIdealStateWithRefresh
            // (swerner) Note: this is outside of the Lingui Provider for i18n and cannot be translated.
            description="Please refresh, or contact a Regrello admin if you continue to see this error."
            title="Something went wrong"
          />
        }
      >
        <App />
      </RegrelloErrorBoundary>
    </React.StrictMode>
  );
}

const appVersion = import.meta.env.VITE_APP_VERSION as string;

init({
  dsn: config.ReactAppSentryDSN,
  environment: config.Environment,
  enableLogs: true, // Required for consoleLoggingIntegration to work.
  integrations: [
    browserTracingIntegration(),
    // Automatically capture all console.warn and console.error logs.
    // This gives us a richer sense of the warnings and errors users are encountering.
    consoleLoggingIntegration({
      levels: ["warn", "error"],
    }),
    replayIntegration({
      maskAllText: config.SentryReplayEnableMasking,
      blockAllMedia: config.SentryReplayEnableMasking,
      // (hchen): After some sampling with manually clicking around the app, looks like it can
      // get up to 3000+ mutation with in the same event loop when rendering opening a task on
      // home page on top of the table. In most cases this number is below 100.
      mutationBreadcrumbLimit: 1000,
      mutationLimit: 5000,
    }),
  ],

  release: appVersion.replace(/[() ]/g, "-"),
  tracesSampleRate: Number.isNaN(Number.parseFloat(config.SentrySampleRate))
    ? 0.0
    : Number.parseFloat(config.SentrySampleRate),
  replaysSessionSampleRate: Number.isNaN(Number.parseFloat(config.SentryReplaySessionSampleRate))
    ? 0.0
    : Number.parseFloat(config.SentryReplaySessionSampleRate),
  replaysOnErrorSampleRate: Number.isNaN(Number.parseFloat(config.SentryReplayOnErrorSampleRate))
    ? 0.0
    : Number.parseFloat(config.SentryReplayOnErrorSampleRate),
});

root.render(<RootComponent />);
